// extracted by mini-css-extract-plugin
export var backdropBlur = "_ko-0";
export var contentCard = "_ko-5";
export var frame = "_ko-2";
export var image = "_ko-4";
export var imagePane = "_ko-3";
export var modal = "_ko-1";